__turbopack_context__.v({
  "imageContainer": "AvatarImage-module-scss-module__v1vKNG__imageContainer",
  "initialContainer": "AvatarImage-module-scss-module__v1vKNG__initialContainer",
});
